import { Link } from 'react-router-dom'

import styled, { css } from 'styled-components'

import { orderStatuses } from './constants'

export const MainContainer = styled(Link)`
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: ${props => props.theme.primitives.radius.radius3};
  &:hover {
    cursor: pointer;
  }

  ${props =>
    props.selected &&
    css`
      background-color: ${props => props.theme.colors.success.surface};
      & > div {
        background-color: ${props => props.theme.colors.success.surface};
      }
    `}
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.background.secondary};
  padding-left: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius3};

  & > div {
    display: flex;
    align-items: center;
    gap: ${props => props.theme.spacing.sp8};
    justify-content: space-between;
  }
`

export const DetailFirstLine = styled.div`
  display: flex;
  justify-content: space-between;

  ${props =>
    props.status === orderStatuses.cancelled &&
    css`
      color: ${props => props.theme.colors.text.subtle};
    `}
`

export const DetailSecondLine = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;

  ${props =>
    props.status === orderStatuses.cancelled &&
    css`
      & div {
        color: ${props => props.theme.colors.text.subtle};
      }
    `}
`

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const StatusContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  div:nth-child(1) {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    width: 175px;
  }
`

export const Deadline = styled.span`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  font-family: ${props => props.theme.texts.bodySRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodySRegular.fontSize};
  color: ${props => (props.days <= 5 ? props.theme.colors.danger.default : props.theme.colors.text.subtle)};
`

export const UpdatedAndDate = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  color: ${props => props.theme.colors.text.default};
`

export const CheckboxContainer = styled.div`
  // Remove checkbox label margin
  & > label {
    margin-right: 0;
  }
`

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8} 12px;
`
